export const kMusicalKeys = [
    "",
    "c",
    "c#",
    "d",
    "d#",
    "e",
    "f",
    "f#",
    "g",
    "g#",
    "a",
    "a#",
    "b",
] as const;

export type MusicalKey = (typeof kMusicalKeys)[number];

export const kChordTypes = ["", "major", "minor"] as const;

export type ChordType = (typeof kChordTypes)[number];

export const toMusicalKey = (value: string): MusicalKey | undefined => {
    const lower = value.toLowerCase();
    return (kMusicalKeys as readonly string[]).includes(lower) ? (lower as MusicalKey) : undefined;
};

export const toChordType = (value: string): ChordType | undefined => {
    const lower = value.toLowerCase();
    return (kChordTypes as readonly string[]).includes(lower) ? (lower as ChordType) : undefined;
};
